import React, { useReducer, useState, useEffect, useCallback, useContext } from 'react';
import { useReducerAsync } from "use-reducer-async";
import { BusinessAccountFormDataReducer, businessAccountFormDataInitialState } from './BusinessAccountFormDataReducer';
import { BusinessAccountFormValidationReducer, businessAccountValidationInitialState } from './BusinessAccountFormValidationReducer';
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { Row, Col, Spinner, Table } from 'react-bootstrap';
import { NewButton as AppButton } from './../../uiwidgets/NewButton';
import { validateInput } from './BusinessAccountValidationService';
import { kickOffFullFormValidation } from 'util/Validators';
import { useParams } from 'react-router-dom';
import { getAccountById, getUsersByAccount } from './BusinessAccountService';
import { listAccountTypes } from './../user-accounts/UserAccountService';
import { AsyncBusinessAccountDataHandlers } from './BusinessAccountFormDataReducer';
import CountrySelect from 'uiwidgets/CountrySelect';
import ProvinceSelect from 'uiwidgets/ProvinceSelect';
import PostalCode from 'uiwidgets/PostalCode';
import { useNavigate } from 'react-router-dom';
import { extractError } from 'api/ErrorUtil';
import _ from "lodash";
import { TenantContext } from '../../tenant/TenantContext';

function BusinessAccount(props) {

  const [formData, formDispatchBusinessAccount] = useReducerAsync(BusinessAccountFormDataReducer, businessAccountFormDataInitialState,
    AsyncBusinessAccountDataHandlers);
  const [formValidityData, formValidityDispatch] = useReducer(BusinessAccountFormValidationReducer, businessAccountValidationInitialState)
  const [dom, setDom] = useState([])
  const navigate = useNavigate();
  const requestParams = useParams();
  const { businessConfig } = useContext(TenantContext);
  
  const onToastClose = () => {
    formDispatchBusinessAccount({ type: 'CLEAR_INFO_AND_ERROR' });
  }

  const handleDropDownChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    formDispatchBusinessAccount({ type: 'SELECT_ACCOUNT_TYPE', payload: { name: name, value: value } });
    handleValidation(event);
  }

  const fetchAccountData = useCallback(async () => {
    let accountTypes = null;
    let account = null;
    try {
      accountTypes = await listAccountTypes();
    } catch (error) {
      let { message, errors, httpStatus } = extractError(error);
      if (httpStatus === 404) {
        formDispatchBusinessAccount({ type: 'ERROR', payload: { errors: { ...errors, message: "Account Types not found" } } })
      } else {
        formDispatchBusinessAccount({ type: 'ERROR', payload: { errors: errors } })
      }
      return;
    }

    if (requestParams.accountId) {
      try {
        account = await getAccountById(requestParams.accountId);
        formDispatchBusinessAccount({ type: "POPULATE_FORM", payload: { account: account, accountTypes: accountTypes } });

      } catch (error) {
        let { message, errors, httpStatus } = extractError(error);
        if (httpStatus === 404) {
          formDispatchBusinessAccount({ type: 'ERROR', payload: { errors: { ...errors, message: "Account  not found" } } })
        } else {
          formDispatchBusinessAccount({ type: 'ERROR', payload: { errors: errors } })
        }
        return;
      }
    } else {
      formDispatchBusinessAccount({ type: "POPULATE_FORM", payload: { accountTypes: accountTypes } });
    }

    const daysOfMonth = []
    for (var i = 1; i <= 31; i++) {
      daysOfMonth.push(i)
    }
    setDom(daysOfMonth)
  });

  useEffect(() => {
    fetchAccountData();
  }, []);

  useEffect(() => {
    fetchAccountData();
  }, [requestParams]);


  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formDispatchBusinessAccount({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
  }

  const handleValidation = (event) => {
    let dispatchType = 'VALIDATE_' + event.target.name.toUpperCase();
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formValidityDispatch({ type: dispatchType, payload: { [name]: value, formData: formData } })
  }

  const handleEmailValidation = (event) => {
    let dispatchType = 'VALIDATE_' + event.target.name.toUpperCase();
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formValidityDispatch({ type: dispatchType, payload: { [name]: value } })
    formDispatchBusinessAccount({ type: "POPULATE_USER_DETAILS_FROM_EMAIL", payload: { [name]: value } });

  }

  const handleCountryChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    let defaultState = "ON";
    if (value === "US") {
      defaultState = "MI";
    }
    formDispatchBusinessAccount({ type: 'FIELD_EDIT', payload: { name: "state", value: defaultState } });
    formDispatchBusinessAccount({ type: 'FIELD_EDIT', payload: { name: name, value: value } });
    handleValidation(event);
  }

  const handleSubmit = async (event) => {
    //console.log('event target label', event.currentTarget.innerText);
    alert("All accounts and profile associated with this email will be updated");
    let btnText = event.currentTarget.innerText;
    event.preventDefault();
    let formDataEvent = {
      ...event,
      formData: formData,
      formDataIsIsolated: true
    }
    let isFormValid = kickOffFullFormValidation(formDataEvent, formValidityDispatch, validateInput);
    if (!isFormValid) {
      alert("The form still has validation errors!");
      return false;
    }
    // setLoading(true);
    let type = (btnText === 'Delete' ? 'Delete' : (btnText === 'Register' ? 'Add' : 'Update'));
    formDispatchBusinessAccount({
      type: 'FORM_SUBMIT', payload: {
        formData: { ...formData, type: type }
      }
    });
  }
  return (
    <FormContainer title={formData.newAccount ? 'Add an Account' : 'Edit Account Number: ' + formData.number} submitButtonFunction={handleSubmit}
      errors={formData.errors} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}>
      <Row>
        <Col>
          If the email exists in the system, all accounts and the user profile associated with email will be updated with the address that you provide on this form. 
        </Col>
      </Row>  
      <Row>
        <Col mb={6} lg={6} sm={6}>
          <FormField label="Account Type" type="select" name="accountTypeId"
            value={formData.accountTypeId||"blank"} onChange={handleDropDownChange} valstate={!formValidityData.accountTypeIdError}
            valMsg={formValidityData.accountTypeIdErrMsg} readOnly={formData.readOnly || formData.accountTypes.length === 1 || !formData.newAccount }>
            <option value="blank" key="blank">Select Account Type</option>
            {formData.accountTypes.map((type, idx) => {
              return (
                <option value={type.id} key={idx}>
                  {type.accountTypeDisplayName}
                </option>
              )
            })}
          </FormField>
        </Col>
        <Col mb={6} lg={6} sm={6} >
          <FormField name="email" label="Email Address" type="text" value={formData.email}
            placeholder="Enter Email Address" onChange={handleChange} onBlur={handleEmailValidation}
            valstate={!formValidityData.emailError} valMsg={formValidityData.emailErrMsg}
            readOnly={formData.readOnly || !formData.newAccount } />
        </Col>
      </Row>

      <Row>
        <Col mb={8} lg={8} sm={12}>
          <FormField name="companyName" label="Client Company Name" type="text" value={formData.companyName}
            placeholder="Company Name" onChange={handleChange} onBlur={handleValidation}
            valstate={!formValidityData.companyNameError} valMsg={formValidityData.companyNameErrMsg}
            readOnly={formData.readOnly} />
        </Col>
      </Row>
    
      <Row>
        <Col mb={6} lg={6} sm={12}>
          <FormField name="firstName" label="Customer First Name" type="text" value={formData.firstName}
            placeholder="First Name" onChange={handleChange} onBlur={handleValidation}
            valstate={!formValidityData.firstNameError} valMsg={formValidityData.firstNameErrMsg}
            readOnly={formData.readOnly} />
        </Col>
        <Col mb={6} lg={6} sm={12}>
          <FormField name="lastName" label="Customer Last Name" type="text" value={formData.lastName}
            placeholder="Last Name" onChange={handleChange} onBlur={handleValidation}
            valstate={!formValidityData.lastNameError} valMsg={formValidityData.lastNameErrMsg}
            readOnly={formData.readOnly} />
        </Col>
      </Row>

      <Row>
        <Col mb={12} lg={12} sm={12}>
          <FormField name="address" label="Address" type="text" value={formData.address}
            placeholder="Enter address" onChange={handleChange} onBlur={handleValidation}
            valstate={!formValidityData.addressError} valMsg={formValidityData.addressErrMsg}
            readOnly={formData.readOnly} />
        </Col>

      </Row>
      <Row>
      <Col mb={2} lg={2} sm={12}>
          <CountrySelect name="country" onChange={(event) => handleCountryChange(event)} onBlur={handleValidation}
            valstate={!formValidityData.countryError} valMsg={formValidityData.countryErrMsg}
            readOnly={formData.readOnly} value={formData.country} />
        </Col>
        <Col mb={4} lg={4} sm={6}>
          <ProvinceSelect name="state" onChange={handleChange} onBlur={handleValidation} value={formData.state}
            valstate={!formValidityData.stateError} valMsg={formValidityData.stateErrMsg}
            readOnly={formData.readOnly} country={formData.country} />
        </Col>

      </Row>
      <Row>
        <Col mb={5} lg={5} sm={12}>
          <FormField name="city" label="City" type="text" value={formData.city}
            placeholder="Enter city" onChange={handleChange} onBlur={handleValidation}
            valstate={!formValidityData.cityError} valMsg={formValidityData.cityErrMsg}
            readOnly={formData.readOnly} />
        </Col>
        <Col mb={4} lg={4} sm={6}>
          <PostalCode name="zip" label="Postal Code" type="text" value={formData.zip}
            placeholder="Enter Postal Code" onChange={handleChange} onBlur={handleValidation}
            valstate={!formValidityData.zipError} valMsg={formValidityData.zipErrMsg}
            readOnly={formData.readOnly} country={formData.country}/>
        </Col>
      </Row>
      <Row>
        <Col mb={6} lg={6} sm={12}>
          <FormField name="mobilePhoneNumber" label="Mobile Phone Number" type="text" value={formData.mobilePhoneNumber}
            placeholder="Mobile Phone Number" onChange={handleChange} onBlur={handleValidation}
            valstate={!formValidityData.mobilePhoneNumberError} valMsg={formValidityData.mobilePhoneNumberErrMsg}
            readOnly={formData.readOnly} />
        </Col>
      </Row>

      <div>
        {formData.loading === true ? (
          <Spinner
            style={{ marginBottom: 27 }}
            animation="border"
            variant="success"
          />
        ) :
          <div>
            {formData.redirectToEdit && <AppButton label="Edit Newly Created Account" onClick={(event) => { navigate("/businessaccounts/" + formData.id) }} />}
            {!formData.redirectToEdit && formData.newAccount &&
              <AppButton label='Register' onClick={(event) => handleSubmit(event)} variant='info' />}

            {!formData.redirectToEdit && !formData.newAccount &&
              <AppButton label='Update' onClick={(event) => handleSubmit(event)} variant='info' />}
            {/* DELETE CANNOT BE SUPPORTED BECAUSE WE CREATE A USER ALONG WITH ACCOUNT
                <AppButton label='Delete' onClick={(event) => handleSubmit(event)} variant='info' />*/}


            &nbsp;&nbsp;<AppButton label='Return to Account List' onClick={(event) => navigate("/businessaccounts")} />
          </div>
        }
      </div>

    </FormContainer>
  )
}
export default BusinessAccount;